import DOMPurify from 'dompurify';

// Inline (cid:) images cannot be resolved in the browser, so they are dropped before sanitizing.
const CID_IMAGE_REGEX = /<img[^>]*src="cid:[^"]*"[^>]*>/gi;

// Inbound email bodies are attacker-controlled. DOMPurify's default allowlist removes
// <script>, every on* handler and javascript: URLs; form controls are also dropped so
// an email cannot render a credential-phishing form inside the CRM origin.
const SANITIZE_OPTIONS = {
  FORBID_TAGS: ['form', 'input', 'button', 'textarea', 'select']
};

/**
 * Email2Case mesaj gövdesini (saldırgan kontrollü, gelen e-posta HTML'i) DOM'a
 * basmadan önce güvenli hale getirir.
 * @param {string} html - message.Body
 * @returns {string} sanitize edilmiş HTML
 */
export const sanitizeEmailHtml = (html) =>
  DOMPurify.sanitize((html || '').replace(CID_IMAGE_REGEX, ''), SANITIZE_OPTIONS);
